module.exports = __webpack_public_path__ + "img/admalumnos.c27c9f9a.png";